import React from 'react';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

/**
 * Place the hour/minute list under the start-time field.
 * rc-time-picker default placement draws the panel on top of the input.
 */
const PANEL_BELOW_INPUT = {
	points: ['tl', 'bl'],
	offset: [0, 4],
	overflow: { adjustX: 1, adjustY: 1 },
};

export default function NozzleTimePicker({ popupClassName = '', popupStyle, ...props }) {
	return (
		<TimePicker
			showSecond={false}
			use12Hours
			{...props}
			getPopupContainer={() => document.body}
			align={PANEL_BELOW_INPUT}
			popupClassName={['nozzle-time-picker-panel', popupClassName].filter(Boolean).join(' ')}
			popupStyle={{ zIndex: 2000, ...(popupStyle || {}) }}
		/>
	);
}
